"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateTestUsersBodyToJSON = exports.GenerateTestUsersBodyFromJSONTyped = exports.GenerateTestUsersBodyFromJSON = void 0;
function GenerateTestUsersBodyFromJSON(json) {
    return GenerateTestUsersBodyFromJSONTyped(json, false);
}
exports.GenerateTestUsersBodyFromJSON = GenerateTestUsersBodyFromJSON;
function GenerateTestUsersBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': json['amount'],
    };
}
exports.GenerateTestUsersBodyFromJSONTyped = GenerateTestUsersBodyFromJSONTyped;
function GenerateTestUsersBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'amount': value.amount,
    };
}
exports.GenerateTestUsersBodyToJSON = GenerateTestUsersBodyToJSON;
